/* eslint-disable @angular-eslint/no-output-native */
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DynamicNGBootstrapRatingComponent } from '@ng-dynamic-forms/ui-ng-bootstrap';

@Component({
  selector: 'dynamic-five-stars.component',
  templateUrl: './dynamic-five-stars.component.html',
  styleUrls: ['./dynamic-five-stars.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
// simple ui override
export class DynamicFiveStarsComponent extends DynamicNGBootstrapRatingComponent {}
